<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <login-card header-color="green" id="loginTop">
        <h4 slot="title" class="title">登录</h4>
       <md-button
           slot="buttons"
           @click="noLogin"
          :style="{width:'40px !important',height:'auto !important',height:isMobile.isMobile?'20px':'',margin:isMobile.isMobile?'0px !important':''}"
          class="md-simple md-white"
          
        >
        <span class='iconfont  icon-weixin1' style='font-size:1.5rem !important;'></span>
         </md-button>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>account_circle</md-icon>
          <label>邮箱/手机</label>
          <md-input v-model="username" type="text" @keydown.enter="submitForm"></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>密码</label>
          <md-input v-model="password" type="password" @keydown.enter="submitForm"></md-input>
        </md-field>
        <md-button slot="footer" class="md-simple md-success md-lg" :style="{height:isMobile.isMobile?'30px':''}" @click="submitForm">
          登 录
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import kit from '../../../../common/js/kit.js';
import { login, userInfo,setUserInformation } from '@/api/user';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
    components: {
        LoginCard,
    },
    data() {
        return {
            username: null,
            password: null,
        };
    },
    computed: {
      ...mapGetters(['isMobile']),
    },
    watch: {},
    created () {},
    mounted () {
    },
    methods: {
      noLogin(){
        this.$store.dispatch('global/showWarningMsg', '微信登录功能暂未开放');
      },
        userInfo (params) {
            let that =this;
            userInfo().then((res) => {
                if (res.code == '200') {
                  kit.setUserInfo(res.data);
                  this.$store.commit('permission/SET_PERMISSIONS', res.data.permissions)
                  this.$store.commit('permission/SET_USER', res.data.user)
                  that.$router.push({path: '/dashboard'});
                }
            })
        },
        setLoginTime(user){
          // 记录登录时间
          // 拿到用户userId
          let loginDate = new Date();
          let params  ={
             userId:user._id||'',
             loginStartTime:moment(loginDate).format(""),
             currentTime:moment().format('')
          }
          setUserInformation(params).then(res=>{
             console.log(res,'============')
          })
        },
        submitForm (params) {
            let that =this;
            if (!this.username) {
              this.$store.dispatch('global/showWarningMsg', '请输入账号');
              return;
            }
            if (!this.password) {
              this.$store.dispatch('global/showWarningMsg', '请输入密码');
              return;
            }
            let tempData ={
                username: that.username,
                password: that.password
            }

            login(tempData).then((res) => {
                if (res.code === '200') {
                    localStorage.setItem('token', `Bearer ${res.data.token}`);
                    that.userInfo();
                }
            })
        }
    }
};
</script>

<style scoped>
   /deep/ #loginTop .md-card-header,.md-card-header-green{
      margin-top:-40px
    }
    @media (max-width:600px){
      .social-line{
        padding: 0px !important;
      }
      /* .social-line button{
        margin: 0px 0px !important;
      } */

      .title{
        font-size: 15px !important;
        margin-bottom: 0px !important;

      }
    }
</style>
